import { render, staticRenderFns } from "./CommonAnchorLink.vue?vue&type=template&id=7edfbb72&scoped=true&"
import script from "./CommonAnchorLink.vue?vue&type=script&lang=js&"
export * from "./CommonAnchorLink.vue?vue&type=script&lang=js&"
import style0 from "./CommonAnchorLink.vue?vue&type=style&index=0&id=7edfbb72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edfbb72",
  null
  
)

export default component.exports